<template>
    <vs-popup class="holamundo add-related-assets-popup" title="Academic metadata" :active.sync="popupActive">
        <div style="padding-right: 15px">
            <vx-input-group class="custom-input-group">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        Concept id
                    </div>
                </template>

                <div class="d-flex">
                    <vs-input
                            name="concept_id"
                            placeholder="Concept id"
                            v-model="concept_id"
                    />
                    <span class="text-danger text-sm validation-error" v-show="errors.has('concept_id')">{{ errors.first('concept_id') }}</span>
                  <vx-tooltip
                    class="help-tip"
                    position="top"
                    text="Embibe Knowledge Graph concept ID.">
                    <i class="material-icons notranslate"> help_outline </i>
                  </vx-tooltip>
                </div>
            </vx-input-group>
            <vx-input-group class="custom-input-group">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        Grade
                    </div>
                </template>

                <div>
                    <vs-input
                            name="grade"
                            v-validate="'required'"
                            placeholder="Grade"
                            v-model="grade"
                    />
                    <span class="text-danger text-sm validation-error" v-show="errors.has('grade')">{{ errors.first('grade') }}</span>
                </div>
            </vx-input-group>
            <vx-input-group class="custom-input-group">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        Subject
                    </div>
                </template>

                <div>
                    <vs-input
                            name="subject"
                            v-validate="'required'"
                            placeholder="Subject"
                            v-model="subject"
                    />
                    <span class="text-danger text-sm validation-error" v-show="errors.has('subject')">{{ errors.first('concept_id') }}</span>
                </div>
            </vx-input-group>
            <vx-input-group class="custom-input-group">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        Chapter
                    </div>
                </template>

                <div>
                    <vs-input
                            name="chapter"
                            v-validate="'required'"
                            placeholder="Chapter"
                            v-model="chapter"
                    />
                    <span class="text-danger text-sm validation-error" v-show="errors.has('chapter')">{{ errors.first('chapter') }}</span>
                </div>
            </vx-input-group>
            <vx-input-group class="custom-input-group">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        Topic
                    </div>
                </template>

                <div>
                    <vs-input
                            name="topic"
                            v-validate="'required'"
                            placeholder="Topic"
                            v-model="topic"
                    />
                    <span class="text-danger text-sm validation-error" v-show="errors.has('topic')">{{ errors.first('topic') }}</span>
                </div>
            </vx-input-group>
        </div>
        <div >
            <vs-button class="shadow-lg" type="gradient" @click="add">Submit</vs-button>
        </div>
    </vs-popup>
</template>

<script>
    export default {
        props: {
            metadata: Object,
            assetId: String
        },
        components: {

        },
        data () {
            return {
                popupActive: true,
                concept_id: '',
                grade: '',
                subject: '',
                chapter: '',
                topic: '',
                res: null
            }
        },
        computed: {

        },
        mounted () {
            this.popupActive = true;
            if (this.metadata) {
                this.concept_id = this.metadata.concept_id;
                this.grade = this.metadata.grade;
                this.subject = this.metadata.subject;
                this.chapter = this.metadata.chapter;
                this.topic = this.metadata.topic;
            }
        },
        created () {

        },
        watch: {
            popupActive() {
                if (!this.popupActive) {
                    this.closeModal();
                }
            }
        },
        methods: {
            add() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        let data = {
                            concept_id: this.concept_id,
                            grade: this.grade,
                            subject: this.subject,
                            chapter: this.chapter,
                            topic: this.topic,
                            asset: this.assetId
                        };
                        if (this.metadata) {
                            let url = '/academic-metadata/' + this.metadata._id;

                            this.$axios.put(url, data)
                                .then(res => {
                                    this.res = res.data;
                                    this.popupActive = false
                                }).catch(err => {
                                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                            })
                        } else {
                            let url = '/academic-metadata';

                            this.$axios.post(url, data)
                                .then(res => {
                                    this.res = res.data;
                                    this.popupActive = false
                                }).catch(err => {
                                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                            })
                        }




                    } else {
                        this.$vs.notifyWrapper({color:'danger', fixed: true, title:'Validation error', text:'Fill all fields'})
                    }
                })
            },
            closeModal(data) {
                setTimeout(() => {
                    this.$emit('closeAddMetaData', this.res);
                }, 1)
            }
        }
    }
</script>
